/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationBackgroundImageModel } from '../../models/organization-background-image-model';

export interface AdminFhirIdBackgroundImageIdGet$Params {
  fhirId: string;
  id: string;
}

export function adminFhirIdBackgroundImageIdGet(http: HttpClient, rootUrl: string, params: AdminFhirIdBackgroundImageIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationBackgroundImageModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdBackgroundImageIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationBackgroundImageModel>;
    })
  );
}

adminFhirIdBackgroundImageIdGet.PATH = '/Admin/{fhirId}/BackgroundImage/{id}';
